import { Component, Inject, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { apiService } from 'src/app/service/api.service';
import { AutoEvaluacionComponent } from '../../auto-evaluacion.component';

@Component({
  selector: 'app-autoevaluacion-resumen',
  templateUrl: './autoevaluacion-resumen.component.html',
  styleUrls: ['./autoevaluacion-resumen.component.css']
})
export class AutoevaluacionResumenComponent implements OnInit {

  resumenRegion = [];
  resumenPrograma = [];

  constructor(
    private api: apiService,    
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.getServerData(); 
  }

  public getServerData(){
    this.spinner.show();
    this.api.API_POST_getResumenAutoevaluacionRegion().subscribe((response: any) => {
      this.resumenRegion = response.payload;
      this.api.API_POST_getResumenAutoevaluacionPrograma().subscribe((response: any) => {
        this.resumenPrograma = response.payload;
        this.spinner.hide();   
      },
      (err) => {
        console.log("error"+err)
      })
        
    },
    (err) => {
      console.log("error"+err)
    })
  }
}


